import React from 'react';

function SuccessBox({ message }: Readonly<{ message: React.ReactNode }>) {
    return (
        <div className="box green-box">
            <p>{message}</p>
        </div>
    );
}

export default SuccessBox;
